import React from "react"

const DeleteAttachmentButton = ({ handleDeleteClicked }) => (
  <a className='remove-attachment' onClick={ handleDeleteClicked }>
    <i className='fa-solid fa-trash-can'></i>
  </a>
)

export default DeleteAttachmentButton
